import React, { useEffect, useState } from "react";
import HomePageModal from "../HomePageModal";
import { BsArrowRight } from "react-icons/bs";

const PopUpOnce = ({ values }) => {
  const [visible, setVisible] = useState(false);
  const [skipAll, setSkipAll] = useState(false);
  const [closedCount, setClosedCount] = useState(0);

  useEffect(() => {
    const popStatus = localStorage.getItem("pop_status");
    if (!popStatus) {
      setVisible(true);
      localStorage.setItem("pop_status", "1");
    }

    window.onbeforeunload = () => {
      localStorage.removeItem("pop_status");
    };
  }, []);

  const totalModals = values?.length || 0;

  if (!visible || closedCount >= totalModals) return null;

  const handleOneModalClose = () => {
    setClosedCount((prev) => prev + 1);
  };

  return (
    <>
      {/* ✅ Global "Skip All" button - Top Center with Red Background */}
      <div
        style={{
          position: "fixed",
          top: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 10000,
          backgroundColor: "#991b1b",
          color: "#fff",
          padding: "10px 20px",
          borderRadius: "5px",
          fontWeight: "bold",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          gap: "8px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        }}
        onClick={() => setSkipAll(true)}
      >
        <span>Skip All</span>
        <BsArrowRight size={18} />
      </div>

      {/* Render all modals */}
      {values?.slice(0, 10).map((i, index) => (
        <HomePageModal
          key={index}
          Iindex={index}
          iTitle={i.title}
          iDocPath={i.file}
          iLink={i.link}
          iZoom={i.zoom}
          skipAll={skipAll}
          onClose={handleOneModalClose}
        />
      ))}
    </>
  );
};

export default PopUpOnce;
